export const project_url = "/ie";
export const admin_string = "/hrn5AM6999V2";
export const secretPass = "XkhZG4fW2t2W";
export const seo_tag_config = false;
export const domain_name = "http://sapi24.com/";
export const FROM_DEFAULT = "contactus@asvpm.org";
export const TO_DEFAULT = "support++apie-stage@predictal.com";
export const MULTI_TENANT = false;
export const welcome_page_text =
  "Welcome to the Agile Practitioner Immersive Experience (APIE). APIE is a SaaS-based CRM platform that serves organizations that offer agile education and training to their practitioners in an immersive experience. APIE is a best-in-class solution in program enablement and operation for educational enterprises, small institutes, and individual coaches that teach the principles of agility to their practitioners.";
